"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SHINE_LEGAL_FORMS = {
    EARL: 'EARL',
    EI: 'EI',
    EIRL: 'EIRL',
    EURL: 'EURL',
    GAEC: 'GAEC',
    OTHER: 'OTHER',
    SARL: 'SARL',
    SAS: 'SAS',
    SASU: 'SASU',
    SCI: 'SCI',
    SCM: 'SCM',
    SNC: 'SNC',
};
const getLegalFormDisplayName = (legalForm) => {
    if (legalForm === SHINE_LEGAL_FORMS.OTHER) {
        return null;
    }
    return legalForm;
};
exports.default = getLegalFormDisplayName;
